import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const languagesK = {
  english: "languages.english",
  danish: "languages.danish",
  german: "languages.german",
};

export const useLanguagesT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      english: t(languagesK.english),
      danish: t(languagesK.danish),
      german: t(languagesK.german),
    }),
    [i18n.language]
  );
};